import './gif.scss';

class Gif {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-gif',
            hoverAttr: 'data-gif-hover'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$image = this.$root.querySelector('img');

        // Options
        this.imgLoaded = false;
        this.originalSrc = this.$image?.src;
        this.stillFrame = null; // Placeholder for the cached still frame
    }

    initialize () {
        if (this.$image) {
            // Wait for the GIF to load fully, then set up controls
            this.onImageLoad(() => {
                // Once the GIF is loaded, show the still frame (pause animation)
                this.toggleAnimation(false);
                // Set up mouse hover events for animation control
                this.setEvents();
            });
        }
    }

    onImageLoad (callback) {
        // Check if the image has already fully loaded
        if (this.$image.complete) {
            // If the image is already loaded, execute the callback immediately
            this.imgLoaded = true;
            callback();
        } else {
            // If the image is not loaded yet, listen for the "onload" event
            this.$image.onload = () => {
                // After the GIF is loaded, execute the callback
                if (!this.imgLoaded) {
                    this.imgLoaded = true;
                    callback();
                }
            };
        }
    }

    createStillFrame (img) {
        if (this.stillFrame) {
            // Return cached still frame if it has already been generated
            return this.stillFrame;
        }

        // Create a canvas to capture the still frame of the GIF
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw the current frame of the image onto the canvas
        context.drawImage(img, 0, 0, img.width, img.height);

        // Cache the still frame as a base64 PNG data URL
        this.stillFrame = canvas.toDataURL('image/png');

        // Return the newly created still frame
        return this.stillFrame;
    }

    toggleAnimation (play) {
        if (play) {
            // Resume the GIF animation by setting the original GIF source
            this.$image.src = this.originalSrc;
        } else {
            // Use the cached still frame if available, otherwise create a new one
            const stillFrame = this.createStillFrame(this.$image);
            this.$image.src = stillFrame;
        }
    }

    setEvents () {
        // Set mouseover event to start GIF animation on hover
        this.$image.addEventListener('mouseover', () => {
            this.toggleAnimation(true);
        });

        // Set mouseleave event to stop GIF animation when no longer hovering
        this.$image.addEventListener('mouseleave', () => {
            this.toggleAnimation(false);
        });
    }
}

export { Gif };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-gif="root"]');
        $$roots.forEach($root => {
            const $rootsAPI = new Gif($root);
            $rootsAPI.initialize();
        });
    }
});
